import Button from "common/components/Button/Button"
import { withFormik } from "formik"
import { InputNumber } from "primereact/inputnumber"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import * as Yup from "yup"
import { newDocumentoSelector } from "../redux/selectors/newDocumentoSelectors"
import { setShowDiasPago } from "../redux/slices/newDocumentoSettingsSlice"
import { setDiasPago } from "../redux/slices/newDocumentoSlice"

const DiasPago = ({
  handleSubmit,
  values,
  setFieldValue,
  onHide,
  isValid,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  return (
    <form
      onSubmit={handleSubmit}
      autoComplete='off'
    >
      <div className='mb-2 p-fluid'>
        <div className='p-field'>
          <label htmlFor='diasPago'>
            {t("crear.facturaRec.modal.paymentDayLabel")}
          </label>

          <InputNumber
            autoFocus
            id='diasPago'
            name='diasPago'
            min={0}
            value={values.diasPago}
            onChange={(e) => setFieldValue("diasPago", e.value)}
          />
        </div>
      </div>

      <div className='mt-4 col'>
        <div className='row justify-content-end align-items-center'>
          <a
            role='button'
            href='#'
            className='mr-3 link-cancel'
            onClick={onHide}
          >
            {t("crear.facturaRec.modal.cancelButton")}
          </a>

          <Button
            className='!tw-bg-primary'
            type='submit'
            disabled={!isValid}
          >
            {t("crear.facturaRec.modal.addButton")}
          </Button>
        </div>
      </div>
    </form>
  )
}

const validate = Yup.object().shape({
  diasPago: Yup.number().min(0).required(),
})

const CreateWithFormik = withFormik({
  validationSchema: validate,
  validateOnMount: true,
  // @ts-expect-error TS(2339): Property 'diasPago' does not exist on type '{}'.
  mapPropsToValues: ({ diasPago }) => ({
    diasPago: diasPago || "",
  }),
  handleSubmit: ({ diasPago }, { props }) => {
    // @ts-expect-error TS(2339): Property 'setDiasPago' does not exist on type 'obj...
    props.setDiasPago(diasPago)
    // @ts-expect-error TS(2339): Property 'showDiasPago' does not exist on type 'ob...
    props.showDiasPago(true)
    // @ts-expect-error TS(2339): Property 'onHide' does not exist on type 'object'.
    props.onHide()
  },
})(DiasPago)

const mapDispatchToProps = (dispatch: $TSMigrationFixMe) => ({
  setDiasPago: (diasPago: $TSMigrationFixMe) => dispatch(setDiasPago(diasPago)),
  showDiasPago: (show: $TSMigrationFixMe) => dispatch(setShowDiasPago(show)),
})

const mapStateToProps = (state: $TSMigrationFixMe) => ({
  diasPago: newDocumentoSelector(state).diasPago,
})

export default connect(mapStateToProps, mapDispatchToProps)(CreateWithFormik)
